import * as React from "react";
import { CheckmarkCircleRegular, DismissCircleRegular } from "@fluentui/react-icons";

interface VisitConceptStatusIconProps {
  realized: boolean;
}

const VisitConceptStatusIcon: React.FC<VisitConceptStatusIconProps> = ({ realized }) => {
  return realized ? (
    <CheckmarkCircleRegular color="green" title="Realized" />
  ) : (
    <DismissCircleRegular color="#d13438" title="Not realized" />
  );
};

export default VisitConceptStatusIcon;
